export default {
    "b":{
      name:'Standard',
      data:[
        {type:'text',name:'Nome e Cognome',required:true, id:'name'},
        {type:'email',name:'email',required:true, id:'email'},
      ]
    }
}